var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgStarChartLogo = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none" }, props), /* @__PURE__ */ React.createElement("path", { fill: "#00F7EF", d: "M0 14.077 15.695 3l-2.589 11.077z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FE346E", d: "m2.225 3.443 2.718 10.634h10.261z" }));
export { SvgStarChartLogo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgMTQuMDc3IDE1LjY5NSAzbC0yLjU4OSAxMS4wNzdIMFoiIGZpbGw9IiMwMEY3RUYiLz48cGF0aCBkPSJtMi4yMjUgMy40NDMgMi43MTggMTAuNjM0aDEwLjI2MUwyLjIyNSAzLjQ0M1oiIGZpbGw9IiNGRTM0NkUiLz48L3N2Zz4=";
